function normalizeBaseUrl(value: string) {
  return value.replace(/\/$/, "");
}

function resolveBrowserApiBaseUrl() {
  if (typeof window === "undefined") {
    return "https://api.catiechess.com";
  }

  const { hostname, origin, protocol } = window.location;

  if (hostname === "catiechess.com" || hostname === "www.catiechess.com") {
    return origin;
  }

  if (protocol === "http:") {
    return `${protocol}//${hostname}:8000`;
  }

  return "https://api.catiechess.com";
}

export const API_BASE_URL = normalizeBaseUrl(
  import.meta.env.VITE_API_BASE_URL?.trim() || resolveBrowserApiBaseUrl(),
);
